import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChild, IChildDietary } from "types";

export interface ChildrenState {
  loaded: boolean;
  items: IChild[];
  selected?: number;
}

const initialState: ChildrenState = { loaded: false, items: [] };

const childrenSlice = createSlice({
  name: "children",
  initialState,
  reducers: {
    fetchChildren: (state, action: PayloadAction<IChild[]>) => {
      state.loaded = true;
      state.items = action.payload;
      state.selected = 0;
    },
    selectChild: (state, action: PayloadAction<number>) => {
      state.selected = action.payload;
    },
    setChildDietary: (
      state,
      action: PayloadAction<{ childId: number; dietary: IChildDietary }>,
    ) => {
      const child = state.items.find(
        (c) => Number(c.id) === action.payload.childId,
      );
      if (child) child.dietary = action.payload.dietary;
    },
  },
});

export const { fetchChildren, selectChild, setChildDietary } =
  childrenSlice.actions;
export default childrenSlice.reducer;
